import { getDirectApplyIntegrationDataHook } from "./integrationDataHooks";
import { getDirectApplyTableDataHook } from "./tableDataHooks";

import { registerSchemaHooks } from "@/features/integrations/shared/renderer/hooks/schemaRegistry";

registerSchemaHooks("direct-apply", {
  getIntegrationDataHook: getDirectApplyIntegrationDataHook,
  getTableDataHook: getDirectApplyTableDataHook,
});
